import React from "react";
import { Box, useTheme, Divider } from "@mui/material";
import { tokens } from "../theme";
import { useState, useEffect } from "react";
import Header from "../components/Header";

const FinancialPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box className="main-container mt-4">
      <Header title="Financial Management"></Header>
    </Box>
  );
};

export default FinancialPage;
